// Client-side mirror of apps/api/src/lib/settlement-money.ts::prorateSettlementNet.
//
// Used ONLY to show a display-only "neto estimado" on a settled payment's
// sale detail — never persisted, never sent back to the API. The real net
// only exists at the batch level (PaymentSettlement.grossCents/transferredCents),
// this just prorates that batch result down to a single payment's weight in
// it, for the operator's reference. See the backend function's doc comment
// for the full rationale (kept in sync here on purpose).
export function prorateSettlementNet(
  paymentAmountCents: number,
  grossCents: number,
  transferredCents: number
): number {
  if (grossCents === 0) return 0;
  return Math.round((paymentAmountCents * transferredCents) / grossCents);
}
